import { useEffect, useRef } from "react";
import { useAuth } from "@/hooks/useAuth";
import { identifyUser, resetUser } from "@/lib/analytics";

/**
 * Ties Supabase auth state into PostHog: identify on sign-in, reset on sign-out.
 * Respects consent — analytics.ts no-ops if the user hasn't opted in.
 */
const AnalyticsAuthBridge = () => {
  const { user } = useAuth();
  const lastIdRef = useRef<string | null>(null);

  useEffect(() => {
    const currentId = user?.id ?? null;
    if (currentId && currentId !== lastIdRef.current) {
      identifyUser(currentId, { email: user?.email });
      lastIdRef.current = currentId;
    } else if (!currentId && lastIdRef.current) {
      resetUser();
      lastIdRef.current = null;
    }
  }, [user?.id, user?.email]);

  return null;
};

export default AnalyticsAuthBridge;